import {FETCH_INSTRUCTOR} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_INSTRUCTOR:
            return action.payload;
        default:
            return state;
    }
};